$(document).ready(function () {

  /***********************************************************************************************************
   * Плавный переход к элементу с указанным ID
   */
  $('a[data-scroll="1"]').click(function (event) {
    event.preventDefault();
    var $target = $($(this).attr('href'));

    $('html, body').animate({
      scrollTop: $target.offset().top - 30,
    }, 500);
  });

  /***********************************************************************************************************
   * Выравнивание высоты блоков
   */
  $('.row-fixed-height').each(function () {
    $row = $(this);
    var maxHeight = 0;
    $row.children().each(function () {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $row.children().each(function () {
      $(this).height(maxHeight);
    });
  });

  /***********************************************************************************************************
   * Подгрузка альбомов по годам
   */
  $(document).on('click', 'a.page-filter__link', function () {
    var $holder = $('.foto-main-cont');
    if ($holder.length === 0) {
      return;
    }
    event.preventDefault();
    var $anchor = $(this);
    $.ajax({
      type: 'GET',
      url: $anchor.attr('href'),
      beforeSend: function () {
        // $anchor.remove();
      },
      success: function (data) {
        if (data) {
          $holder.html(data);

          $('.photo-video-sl').slick({
            responsive: [
              {
                breakpoint: 99999,
                settings: 'unslick',
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  dots: true,
                },
              },
              {
                breakpoint: 460,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                },
              },
            ],
          });
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log('Ошибка отправки AJAX: ' + xhr.status);
        console.log(xhr.responseText);
        console.log(thrownError);
      },
      complete: function () {
        $('a.page-filter__link').removeClass('active');
        $anchor.addClass('active');
      },
    });
  });

  /***********************************************************************************************************
   * Подгрузка альбомов
   */
  $(document).on('click', 'a.goto-photo', function () {
    event.preventDefault();
    var $anchor = $(this);
    var $wrapper = $(this).hide().closest('.page-section-blocks').children('.photo-video-sl');
    $.ajax({
      type: 'GET',
      url: $anchor.attr('href'),
      beforeSend: function () {
        $anchor.remove();
      },
      success: function (data) {
        if (data) {
          $wrapper.append(data);

          var maxHeight = 0;
          $('.photo-video-block').each(function () {
            if ($(this).height() > maxHeight) {
              maxHeight = $(this).height();
            }
          });
          $('.photo-video-block').height(maxHeight);
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log('Ошибка отправки AJAX: ' + xhr.status);
        console.log(xhr.responseText);
        console.log(thrownError);
      },
      complete: function () {
        // $buttonSubmit.attr('disabled', false);
      },
    });
  });

  /***********************************************************************************************************
   * Разворачивание отзывов
   */
  $('[data-role="expand-content"]').each(function () {
    var $parent = $(this).parent();
    if ($(this)[0].scrollHeight <= $parent.innerHeight()) {
      $('[data-action="expand-toggle"]', $(this).closest('[data-role="expand-holder"]')).remove();
    }
  });
  $('[data-action="expand-toggle"]').click(function (event) {
    event.preventDefault();
    var isExpanded = $(this).attr('data-expanded') == '1';

    var $contentBlock = $('[data-role="expand-content"]', $(this).closest('[data-role="expand-holder"]'));

    if (isExpanded) {
      $(this).attr('data-expanded', '0');
      $(this).html($(this).attr('data-text-default'));
      $contentBlock.removeClass('expanded');
    }else {
      $(this).attr('data-expanded', '1');
      $(this).html($(this).attr('data-text-expanded'));
      $contentBlock.addClass('expanded');
    }
  });

  /***********************************************************************************************************
   * Форма обратной связи
   */
  $(document).on('submit', 'form[data-action="send-request-feedback"]', function (event) {
    event.preventDefault();

    var $form = $(event.target);
    var $buttonSubmit = $form.find('button[type="submit"]');

    $form.find('.is-error').removeClass('is-error');
    $('[data-role="form-err-message"]', $form).addClass('hidden');
    $('[data-role="form-err-message"]', $form).text('');

    var $agreement = $('[data-role="checkbox-agreement"]', $form);
    if ($agreement.length > 0 && !$agreement.is(':checked')) {
      $('[data-role="form-err-message"]', $form).removeClass('hidden');
      $('[data-role="form-err-message"]', $form).text('Необходимо принять политику конфиденциальности');
      return;
    }

    var formData = null;
    if (window.FormData) {
      formData = new FormData($form[0]);
      formData.append('isNaked', true);
    }

    $.ajax({
      type: 'POST',
      url: $form.attr('action'),
      dataType: 'json',
      data: formData ? formData : $form.serialize() + '&isNaked=1',
      contentType: formData ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
      processData: formData ? false : true,
      beforeSend: function () {
        $buttonSubmit.attr('disabled', true);
      },
      success: function (data) {
        var errText = false;
        if (typeof data.scs !== 'undefined' && typeof data.msg !== 'undefined') {
          if (data.scs) {
            $('[data-role="form-body"]', $form).addClass('hidden');
            $('[data-role="form-sended"]', $form).removeClass('hidden');
            return;
          }else {
            if (data.msg === 'err-no-name') {
              $('[name="f_ContactName"]', $form).parent().addClass('is-error');
              return;
            }
            if (data.msg === 'err-no-info') {
              $('[name="f_ContactInfo"]', $form).parent().addClass('is-error');
              return;
            }
          }
        }

        // Неизвестная ошибка
        $('[data-role="form-err-message"]', $form).removeClass('hidden');
        $('[data-role="form-err-message"]', $form).text('Неизвестная ошибка');

      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log('Ошибка отправки AJAX: ' + xhr.status);
        console.log(xhr.responseText);
        console.log(thrownError);
      },
      complete: function () {
        $buttonSubmit.attr('disabled', false);
      },
    });

    return false;
  });

  /***********************************************************************************************************
   * Форма добавления отзыва
   */
  $(document).on('submit', 'form[data-action="send-request-review"]', function (event) {
    event.preventDefault();

    var $form = $(event.target);
    var $buttonSubmit = $form.find('button[type="submit"]');

    $form.find('.is-error').removeClass('is-error');
    $('[data-role="form-err-message"]', $form).addClass('hidden');
    $('[data-role="form-err-message"]', $form).text('');

    var $agreement = $('[data-role="checkbox-agreement"]', $form);
    if ($agreement.length > 0 && !$agreement.is(':checked')) {
      $('[data-role="form-err-message"]', $form).removeClass('hidden');
      $('[data-role="form-err-message"]', $form).text('Необходимо принять политику конфиденциальности');
      return;
    }

    var formData = null;
    if (window.FormData) {
      formData = new FormData($form[0]);
      formData.append('isNaked', true);
    }

    $.ajax({
      type: 'POST',
      url: $form.attr('action'),
      dataType: 'json',
      data: formData ? formData : $form.serialize() + '&isNaked=1',
      contentType: formData ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
      processData: formData ? false : true,
      beforeSend: function () {
        $buttonSubmit.attr('disabled', true);
      },
      success: function (data) {
        var errText = false;
        console.log(data);
        if (typeof data.scs !== 'undefined' && typeof data.msg !== 'undefined') {
          if (data.scs) {
            $('[data-role="form-body"]', $form).addClass('hidden');
            $('[data-role="form-sended"]', $form).removeClass('hidden');
            return;
          }else {
            if (data.msg === 'err-no-fullname') {
              $('[name="f_FullName"]', $form).parent().addClass('is-error');
              return;
            }
            if (data.msg === 'err-no-content') {
              $('[name="f_Content"]', $form).parent().addClass('is-error');
              return;
            }
          }
        }

        // Неизвестная ошибка
        $('[data-role="form-err-message"]', $form).removeClass('hidden');
        $('[data-role="form-err-message"]', $form).text('Неизвестная ошибка');

      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log('Ошибка отправки AJAX: ' + xhr.status);
        console.log(xhr.responseText);
        console.log(thrownError);
      },
      complete: function () {
        $buttonSubmit.attr('disabled', false);
      },
    });
  });


  $(document).on('click', function (event) {
    $('.headerlinks-menu__item-link').attr('active', '0');
  });


  // Косяки верхнего меню
  $(document).on('click', '.headerlinks-menu__item-link', function (event) {
    var $anchor = $(this);
    var $holder = $anchor.parent();
    if (matchMedia('only screen and (max-width: 767px)').matches && $('.header-links-menu-sub', $holder).length > 0) {
      if ($anchor.attr('active') != '1') {
        event.preventDefault();
        setTimeout(function () {
          $anchor.attr('active', '1');
        }, 150);
      }
    }
  });

});
